import { render, staticRenderFns } from "./AddIujpSearch.vue?vue&type=template&id=68e747cd&scoped=true&"
import script from "./AddIujpSearch.vue?vue&type=script&lang=js&"
export * from "./AddIujpSearch.vue?vue&type=script&lang=js&"
import style0 from "./AddIujpSearch.vue?vue&type=style&index=0&id=68e747cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e747cd",
  null
  
)

export default component.exports